import ArrayInput from "app/utils/form/ArrayInput";
import { ActionDataGrid4 } from "../../form/ActionDataGrid4"
import { Formik } from "formik";
import { useState } from "react";
function renderDietaryCategory(params: any, inputCatagory: any) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [data, setData] = useState([{ text: params.data.dietaryCategory3, value: params.data.idDietaryCategory3 }])
    return (<>
        <span className="title-category">{params.data.dietaryCategory3All || params.data.dietaryCategory3}</span>
        <Formik
            initialValues={{ dietaryCategory3: data }}
            onSubmit={() => {
            }}
        >
            <ArrayInput arrayInput={[inputCatagory]} />
        </Formik>
    </>)
}
export const columnDefStep4 = (editStepGrid: any, callbackEdit: any, props: any, dataRow4: any, setDataRow4: any): any => {
    return [
        { field: 'id', hide: true },
        {
            field: 'fatherStructure3',
            headerName: 'Estructura',
            minWidth: 130,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'dietaryCategory3',
            headerName: 'Categoría Dietética',
            minWidth: 390,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
            suppressRowTransform: true,
            cellClass: 'overflow-visible',
            cellRenderer: (params: any) => {
                if (params.data.load || props.bloqueado) {
                    const propCat = props.data.categoriaDieteticaRec;
                    const inputCatagory: any =
                    {
                        columInput: 1,
                        campo: 'dietaryCategory3',
                        label: '',
                        type: 'tree-select',
                        style: { width: '100%', zIndex: 5 },
                        treeData: propCat,
                        onChangeTree: async (
                            setFieldValue: any,
                            values: any,
                            arrayInput: any,
                            currentNode: any,
                            selectedNodes: any
                        ) => {
                            params.data.dietaryCategory3 = values.dietaryCategory3[0].text
                            params.data.idDietaryCategory3 = values.dietaryCategory3[0].value
                            params.data.dietaryCategory3All = values.dietaryCategory3[0].tagLabel
                            const editRow = dataRow4.map((item: any) => {
                                if (item.id === params.data.id) {
                                    item = params.data;
                                }
                                return item;
                            });
                            setDataRow4(editRow);
                        },
                        className: 'bootstrap-demo w-100',
                    }
                    return renderDietaryCategory(params, inputCatagory)

                } else {
                    return (<span className="categoria-dietetica">{params.data.dietaryCategory3All || params.data.dietaryCategory3}</span>)
                }
            }
        },
        {
            field: 'mainIngredients2',
            headerName: 'Ingrediente Principal',
            minWidth: 130,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'frequency',
            headerName: 'Frecuencia',
            minWidth: 100,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
        },
        {
            field: 'cycles4',
            headerName: 'Semanas',
            minWidth: 130,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
            hide: false,
        },
        {
            field: 'comodin',
            headerName: 'Comodín',
            minWidth: 100,
            suppressMenu: true,
            filter: true,
            floatingFilter: true,
            hide: true,
        },
        {
            field: 'Acción',
            minWidth: 150,
            cellRenderer: (params: any) => {
                if (props.bloqueado) {
                    return <></>
                } else {
                    return params.data.load ? <></>
                        :
                        <>
                            {editStepGrid(params, callbackEdit, props.formikProps)}
                            <ActionDataGrid4 dataRow={params.node.data} />
                        </>
                }
            },
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true,
        },
    ]
}